import { render, staticRenderFns } from "./OurStoryContd.vue?vue&type=template&id=42228af8&scoped=true"
import script from "./OurStoryContd.vue?vue&type=script&lang=ts"
export * from "./OurStoryContd.vue?vue&type=script&lang=ts"
import style0 from "./OurStoryContd.vue?vue&type=style&index=0&id=42228af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42228af8",
  null
  
)

export default component.exports